var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import onlineimg from "../../../../../assets/images/features/BasicProfile/online-img.svg";
import uploadimg from "../../../../../assets/images/features/BasicProfile/upload.svg";
import closeimg from "../../../../../assets/images/features/BasicProfile/close.svg";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { FeedbackEntity, } from "@domains/entities/interfaces/iFeedback";
import di from "@mainDi/features/webHome";
import TeaxtareaField from "@frameworks/web/components/generic/textarea";
import { useSelector } from "react-redux";
import _ from "underscore";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
export var ToasterMsg;
(function (ToasterMsg) {
    ToasterMsg["SuccessMsg"] = "We\u2019ve received your feedback! Thank you.";
    ToasterMsg["FailureMsg"] = "Something went wrong! Please try after sometime.";
})(ToasterMsg || (ToasterMsg = {}));
var FeedbackData = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(React.useState([]), 2), files = _e[0], setFiles = _e[1];
    var _f = __read(useState([
        {
            title: "Design and Interface",
            value: "Design and Interface",
        },
        {
            title: "Account Opening",
            value: "Account Opening",
        },
        {
            title: "Investment Related",
            value: "Investment Related",
        },
        {
            title: "Customer Service",
            value: "Customer Service",
        },
        {
            title: "Suggestions",
            value: "Suggestions",
        },
        {
            title: "Pricing alerts",
            value: "Pricing alerts",
        },
    ]), 2), historicReturnsDropdown = _f[0], setHistoricReturnsDropdown = _f[1];
    var _g = __read(useState({
        title: "",
        value: "",
    }), 2), selectedDropdownValue = _g[0], setSelectedDropdownValue = _g[1];
    var _h = __read(React.useState(false), 2), fileError = _h[0], setFileError = _h[1];
    var device = DeviceContext();
    var _j = __read(useState({
        isShow: false,
        msg: "",
    }), 2), status = _j[0], setStatus = _j[1];
    var _k = __read(useState({
        selectoption: selectedDropdownValue === null || selectedDropdownValue === void 0 ? void 0 : selectedDropdownValue.value,
        comment: "",
        imgs: undefined,
    }), 2), formData = _k[0], setFormData = _k[1];
    var _l = __read(useState({
        selectoption: "",
        comment: "",
        imgs: "",
    }), 2), error = _l[0], setError = _l[1];
    var handleSubmitFile = function (fileDetails) {
        var fileInfo = {
            fileContent: "",
            fileName: "",
        };
        if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
            fileInfo = {
                fileContent: fileDetails.base64Data.split(",")[1],
                fileName: fileDetails.docFile,
            };
            setFormData(__assign(__assign({}, formData), { imgs: [fileInfo] }));
        }
        else {
            setFormData(__assign(__assign({}, formData), { imgs: [] }));
        }
    };
    var feedbackSubmit = function (e) {
        e.preventDefault();
        feedBackFormSubmit(formData, e);
        // handleSubmitFile();
    };
    var onSelectFile = function (e) {
        uploadFile(e.target.files[0]);
    };
    var handleChange = function (event) {
        setFormData(function (formdata) {
            var _a;
            return __assign(__assign({}, formdata), (_a = {}, _a[event.target.name] = event.target.value, _a));
        });
    };
    var AllClientDetails = useSelector(function (state) { var _a; return (_a = state.BasicProfile.ClientDetailsReducer.data) === null || _a === void 0 ? void 0 : _a.client; }, _.isEqual);
    // const disable = useMemo(
    //   () => formData?.comment?.length <= 0 || formData?.selectoption?.length <= 0,
    //   [formData]
    // );
    var validationError = function (field, title) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = title, _a)));
    };
    var feedBackFormSubmit = function (formData, e) { return __awaiter(void 0, void 0, void 0, function () {
        var imgs, feedBackData, resp;
        return __generator(this, function (_a) {
            imgs = [];
            files.map(function (item) {
                var fileInfo = {
                    fileName: item.ImgNm,
                    fileContent: item.ImgCont.replace("data:", "").replace(/^.+,/, ""),
                };
                imgs.push(fileInfo);
            });
            feedBackData = new FeedbackEntity(AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.accName, AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.email, AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.mobileNo, formData.selectoption, formData.comment, imgs, "Basic Profile", AllClientDetails.acCode);
            console.log("err", error);
            if ((error === null || error === void 0 ? void 0 : error.comment) === "" &&
                (error === null || error === void 0 ? void 0 : error.selectoption) === "" &&
                (error === null || error === void 0 ? void 0 : error.imgs) === "") {
                resp = di.home.sendFeedback(feedBackData);
                if (resp) {
                    toasterWindowHandler(true, ToasterMsg.SuccessMsg);
                    setTimeout(function () {
                        props.goBack && props.goBack();
                    }, 3000);
                }
                else {
                    toasterWindowHandler(true, ToasterMsg.FailureMsg);
                }
                setFormData(__assign(__assign({}, formData), { imgs: [], comment: "", selectoption: "" }));
            }
            return [2 /*return*/];
        });
    }); };
    var toasterWindowHandler = function (show, msg) {
        setStatus({
            isShow: show,
            msg: msg,
        });
    };
    var removeFile = function (index) {
        setFiles(files.filter(function (_, i) { return i !== index; }));
    };
    var dropHandler = function (e) {
        e.preventDefault();
        if (e.dataTransfer.items) {
            for (var i = 0; i < e.dataTransfer.items.length; i++) {
                if (e.dataTransfer.items[i].kind === "file") {
                    uploadFile(e.dataTransfer.items[i].getAsFile());
                }
            }
        }
    };
    var uploadFile = function (fileDetails) {
        if (fileDetails.size > 1048576 ||
            fileDetails.type.split("/")[0] !== "image") {
            if (!fileError)
                setFileError(true);
            return;
        }
        if (fileError)
            setFileError(false);
        var reader = new FileReader();
        reader.readAsDataURL(fileDetails);
        reader.onload = function () {
            setFiles(__spreadArray(__spreadArray([], __read(files), false), [
                {
                    ImgCont: reader.result,
                    ImgNm: fileDetails.name,
                    Type: fileDetails.type,
                },
            ], false));
        };
        reader.onerror = function () { };
    };
    var handleDropdownChange = function (e) {
        setSelectedDropdownValue(e);
        setFormData(__assign(__assign({}, formData), { selectoption: e === null || e === void 0 ? void 0 : e.value }));
    };
    return (React.createElement("div", { className: "basic-feedback-main-block" },
        React.createElement("form", { onSubmit: function (e) { return feedbackSubmit(e); } },
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "px-4 mgt-30" },
                    React.createElement(Col, { lg: 6 },
                        React.createElement("div", { className: "mb-2 DMSanN_14_400 headers" },
                            " ",
                            "Category of feedback"),
                        React.createElement(EquityDropdown, { itemlist: historicReturnsDropdown, defaultVal: false, externalClassname: "common-new-drp new-upi-drp", bigIcon: true, align: "start", selectedValue: handleDropdownChange, defaultText: "Select category of feedback" }))),
                React.createElement(Col, { lg: 12, className: "px-4 mgt-30" },
                    React.createElement("div", { className: "mb-2 DMSanN_14_400 headers" }, "Comments"),
                    React.createElement(TeaxtareaField, { className: "commentbox-section", placeholderClassName: "holder", defaultValue: formData.comment, placeholder: "", label: true, id: "comment", name: "comment", required: false, errorText: error.comment, onChangeEvent: function (e) {
                            handleChange(e);
                        }, onBlur: function (error, event) {
                            if (error.required)
                                validationError(event.target.name, "This field is Required");
                            else
                                validationError(event.target.name, "");
                        } })),
                React.createElement(Col, null,
                    React.createElement("label", { className: "empty_file", onDrop: dropHandler, onDragOver: function (e) { return e.preventDefault(); }, onDragEnter: function (e) { return e.preventDefault(); } },
                        React.createElement("input", { type: "file", onChange: onSelectFile, accept: "image/*", hidden: true, onClick: function (e) { return (e.target.title = ""); } }),
                        React.createElement("img", { src: uploadimg }),
                        React.createElement("span", { className: "text txt_midnight_blue DMSanM_14_500 txt-midnight-blue" }, "\u00A0Upload screenshot")),
                    files.length > 0 && (React.createElement("div", { className: "file_block" },
                        files.map(function (file, index) { return (React.createElement("div", { className: "image_cont", key: index },
                            React.createElement("div", { className: "imgbtn_grp" },
                                (file.Type === "image/jpeg" ||
                                    file.Type === "image/jpg" ||
                                    file.Type === "image/png") && (React.createElement("div", null,
                                    React.createElement("img", { src: file.ImgCont }))),
                                file.Type !== "image/jpeg" &&
                                    file.Type !== "image/jpg" &&
                                    file.Type !== "image/png" && (React.createElement("span", { className: "edel-icon-excel excel_icon" })),
                                React.createElement("span", { onClick: function () { return removeFile(index); } },
                                    React.createElement("img", { src: closeimg, className: "icon-close" }))),
                            (file.Type === "image/jpeg" ||
                                file.Type === "image/jpg" ||
                                file.Type === "image/png") && (React.createElement("div", { className: "mt-1 DMSanM_10_500 txt_primaryGrey" }, file.ImgNm)))); }),
                        files.length < 3 && (React.createElement("div", { className: "new_file image_cont" },
                            React.createElement("label", { className: "new_file imgbtn_grp", onDrop: dropHandler, onDragOver: function (e) { return e.preventDefault(); }, onDragEnter: function (e) { return e.preventDefault(); } },
                                React.createElement("input", { type: "file", onChange: onSelectFile, accept: "image/*", id: "file-upload", hidden: true, onClick: function (e) {
                                        return (e.target.title = "");
                                    } }),
                                React.createElement("div", { "aria-hidden": "true" },
                                    React.createElement("i", { className: "edel-icon-plus" }))),
                            React.createElement("span", null, "\u00A0"))),
                        files.length < 1 && (React.createElement("label", { htmlFor: "file-upload", className: "file_msg DMSanM_14_500 txt_midnight_blue" }, "Upload Screenshot")))),
                    fileError && (React.createElement("span", { className: "errMsg" }, "File format should be PNG, JPG, JPEG & not more than 1 MB."))),
                device && device.isDesktop ? (React.createElement(React.Fragment, null,
                    React.createElement(Col, { lg: 12, className: "px-4 mgt-30 setting-content-btn mb-4 uploadscreen-section" },
                        React.createElement("div", null,
                            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", className: "pe-2 ps-2 w-160", onClick: feedbackSubmit, disabled: ((_a = formData === null || formData === void 0 ? void 0 : formData.comment) === null || _a === void 0 ? void 0 : _a.length) <= 0 ||
                                    ((_b = formData === null || formData === void 0 ? void 0 : formData.selectoption) === null || _b === void 0 ? void 0 : _b.length) <= 0 ||
                                    fileError, type: "submit" })),
                        React.createElement("div", { className: "text-right" },
                            React.createElement("div", { className: "circle-img" },
                                React.createElement("img", { src: onlineimg })))))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mt-5" }),
                    React.createElement(Col, { className: "col-6 ps-4 pt-3 pb-3" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: " w-100", onClick: function () { return props.goBack && props.goBack(); } })),
                    React.createElement(Col, { className: "col-6 pe-4  pt-3 pb-3" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", className: " w-100", disabled: ((_c = formData === null || formData === void 0 ? void 0 : formData.comment) === null || _c === void 0 ? void 0 : _c.length) <= 0 ||
                                ((_d = formData === null || formData === void 0 ? void 0 : formData.selectoption) === null || _d === void 0 ? void 0 : _d.length) <= 0 ||
                                fileError, type: "submit" }))))),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12 },
                    React.createElement(Toaster, { show: status.isShow, setShow: function (val) {
                            return setStatus({
                                isShow: val,
                                msg: "",
                            });
                        }, message: status.msg, position: "bottom-end", parentClass: "desk-toast toast-remove-position" }))))));
};
export default FeedbackData;
